import type { PermissionCode } from '@/shared/permissions';

export const CONTENT_PERMISSIONS = {
  view: 'content.view',
  manage: 'content.manage',
} as const satisfies Record<string, PermissionCode>;

